<template>
  <div>
    <Banner />
    <About />
    <div class="breaker-pattern"></div>
    <Speakers />
    <div class="breaker-pattern"></div>
    <LightningTalk />
    <div class="breaker-pattern"></div>
    <Host />
    <div class="breaker-pattern"></div>
    <Calendar />
    <div class="breaker-pattern"></div>
    <Frequentques />
    <div class="breaker-pattern"></div>
    <FutureUpdates />
    <Footer />
    <SidebarSpeaker v-if="openSideboxSpeaker" :speaks="speaks" />
    <SidebarEvent v-if="openSideboxEvent" :events="events" />
    <SideHostBar v-if="openSideboxHost" />
  </div>
</template>

<script>
import { bus } from "../main";
import Banner from "../components/Banner.vue";
import Footer from "../components/Footer.vue";
import About from "../components/About.vue";
import Speakers from "../components/Speakers.vue";
import Host from "../components/HostEvent.vue";
import SideHostBar from "../components/SideHostBar.vue";
import Calendar from "../components/Calendar.vue";
import Frequentques from "../components/Frequentques.vue";
import FutureUpdates from "../components/FutureUpdates.vue";
import SidebarSpeaker from "../components/SideSpeakerbar.vue";
import SidebarEvent from "../components/SideEventbar.vue";
import LightningTalk from "../components/LightningTalk.vue";

export default {
  name: "Homepage",
  metaInfo: {
    title: "This is the the test of meta tag",
    titleTemplate: "%s | vue-meta Example App",
    htmlAttrs: {
      lang: "en-US",
    },
    meta: [
      { charset: "utf-8" },
      {
        name: "Syntax 2021",
        content:
          "Syntax 2021 is a platform to share well-formed thoughts, ideas, and experiences around innovation and technology. Global Conference.",
      },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { title: "Syntax 2021 Global Conference Booking." },
      { vmid: "og:image", property: "og:image"},
    ],
  },
  components: {
    Banner,
    Footer,
    About,
    Speakers,
    Calendar,
    Frequentques,
    FutureUpdates,
    LightningTalk,
    SidebarSpeaker,
    SidebarEvent,
    SideHostBar,
    Host,
  },

  created() {
    bus.$on("openSideboxSpeaker", (data) => {
      this.openSideboxSpeaker = true;
      this.speaks = data;
    });
    bus.$on("closeSideboxSpeaker", () => {
      this.openSideboxSpeaker = false;
    });
    bus.$on("openSideboxEvent", (data) => {
      this.openSideboxEvent = true;
      this.events = data;
    });
    bus.$on("closeSideboxEvent", () => {
      this.openSideboxEvent = false;
    });
    bus.$on("openSideboxHost", () => {
      this.openSideboxHost = true;
    });
    bus.$on("closeSideboxHost", () => {
      this.openSideboxHost = false;
    });
  },

  data() {
    return {
      openSideboxSpeaker: false,
      openSideboxEvent: false,
      openSideboxHost: false,
      speaks: null,
      events: null,
    };
  },
};
</script>
